if (!customElements.get('sales-notification')) {
  class SalesNotification extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('.sales-notification__close');
      this.storageKey = 'sales-notification-closed';
    }

    connectedCallback() {
      // Check if already dismissed
      if (this.isDismissed()) {
        this.remove();
        return;
      }

      // Animate in
      requestAnimationFrame(() => {
        this.classList.add('is-visible');
      });

      // Bind close button
      this.closeButton?.addEventListener('click', this.close.bind(this));
    }

    isDismissed() {
      try {
        const dismissed = sessionStorage.getItem(this.storageKey);
        return dismissed === 'true';
      } catch (e) {
        return false;
      }
    }

    close() {
      this.classList.remove('is-visible');
      this.classList.add('is-closing');
      
      // Save dismissal for session
      try {
        sessionStorage.setItem(this.storageKey, 'true');
      } catch (e) {
        // Storage not available
      }

      // Remove after animation
      this.addEventListener('transitionend', () => {
        this.remove();
      }, { once: true });
    }
  }

  customElements.define('sales-notification', SalesNotification);
}